import { render, staticRenderFns } from "./fccTesteGabarito.vue?vue&type=template&id=77bc5ce1"
import script from "./fccTesteGabarito.vue?vue&type=script&lang=js"
export * from "./fccTesteGabarito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports